import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {IPropertyService} from "./property.service-interface";
import gql from "graphql-tag";
import {Apollo} from "apollo-angular";
import {VisbosService} from "../../../core/visbos-core/graphql/visbos.service";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../shared/redux-store/store";
import {SessionActions} from "../../../shared/actions/session.actions";
import {map} from "rxjs/operators";

export const fetchPropertiesQuery = gql`
        query FetchPropertiesQuery($cuid: String) {
          fetchProperties(cuid: $cuid) {
          cuid, label, name, short_name
          }
        }`;

@Injectable()
export class PropertyService extends VisbosService implements IPropertyService {


  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions) {
    super(apollo, ngRedux, sessionActions);
  }

  public getPropertiesList(): Observable<any> {

    //TODO: Implement stub

    let data$ = this.fetchItems({
      query: fetchPropertiesQuery,
      variables: {
        cuid: null
      }
    });

    let model$ = data$.pipe(map(({data}:any) => data.fetchProperties));

    return model$;
  }

  public getProperty(cuid: string): Observable<any> {

    //TODO: Implement stub

    let data$ = this.fetchItems({
      query: fetchPropertiesQuery,
      variables: {
        cuid: cuid
      }
    });

    let model$ = data$.pipe(map(({data}:any) => {
        return {
          property: data.fetchProperties[0],
          isLoading: data.loading
        };
      }
    ));


    return model$;
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/services/property-service/property.service.ts